import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(fdvID) {

    const config = {
    params: {
        codFiveAdj: '1',
    },
    headers: {
      indPaginado:  'N',
      nroPag:  1,
      cantidadxPag:  10,
      codUsuario : IDUSUARIO,
    },
  };
  
 

  return customAxios.get(`${FDV_URL}/archivoAdjunto/adjuntar/${fdvID}`,config);
}


// WEBPACK FOOTER //
// ./src/utils/getListaArchivos.js